import { memo, useMemo, useRef } from 'react'

import useUniqID from '@aytm/lib/hooks/useUniqID'

import { CompareItemsTableAddItemImageCell as TCompareItemsTableAddItemImageCell } from '../../types'

import style from './AddItemImage.module.scss'

export default memo(
  CompareItemsTableAddItemImage,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableAddItemImage({
  className,
  width
}: {
  className: string
  width: number
  cell: TCompareItemsTableAddItemImageCell
}) {
  const svgFilterID = useUniqID('plussignshadow-')

  const plusSignSVG = useMemo(
    () => (
      <svg width="70" height="70" viewBox="0 0 28 28" className={style.svgPlus}>
        <defs>
          <filter id={svgFilterID} colorInterpolationFilters="sRGB">
            <feFlood floodOpacity=".5" floodColor="#666" result="flood"></feFlood>
            <feComposite in="flood" in2="SourceGraphic" operator="in" result="composite1"></feComposite>
            <feGaussianBlur in="composite1" stdDeviation="0.8" result="blur"></feGaussianBlur>
            <feOffset result="offset"></feOffset>
            <feComposite in="SourceGraphic" in2="offset" result="composite2"></feComposite>
          </filter>
        </defs>
        <path
          d="M14.8 270.2a12 12 0 0 0-12 12 12 12 0 0 0 12 12 12 12 0 0 0 12-12 12 12 0 0 0-12-12zm-.24 5.98h.48c.274 0 .494.22.494.494v4.827H20.2c.323 0 .584.26.584.584v.23c0 .324-.26.584-.584.584h-4.667v4.827c0 .273-.22.494-.494.494h-.48a.492.492 0 0 1-.494-.494v-4.827H9.4a.583.583 0 0 1-.584-.584v-.23c0-.324.26-.584.584-.584h4.667v-4.827c0-.273.22-.494.494-.494z"
          color="#c7edea"
          overflow="visible"
          fill="#c7edea"
          enableBackground="accumulate"
          filter={`url(#${svgFilterID})`}
          transform="translate(-0.8 -268.2)"
          style={{ isolation: 'auto', mixBlendMode: 'normal' }}
        ></path>
      </svg>
    ),
    [svgFilterID]
  )

  const cellRef = useRef<HTMLDivElement>(null)
  const onClick = () => {
    if (cellRef.current) {
      const root = cellRef.current.closest<HTMLDivElement>('[data-compare-items="root"]')
      const addItemSelector = root?.querySelector<HTMLDivElement>(
        '[data-compare-items="add-item-cell"] .rfd-ui-inline-select'
      )
      addItemSelector?.click?.()
    }
  }

  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableAddItemImage}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
      onClick={onClick}
      ref={cellRef}
    >
      {plusSignSVG}
    </div>
  )
}
